/**
 * Shared utility for handling rate limit errors (HTTP 429)
 * This function extracts the error message, marks the error, and dispatches a custom event
 */
export const handleRateLimitError = (error) => {
  // Extract the error message from the response
  const rateLimitMessage = error.response?.data?.message || 
                           error.response?.data?.error || 
                           'Too many requests from this IP, please try again later.';
  
  // Create a custom error object with the rate limit message
  const rateLimitError = new Error(rateLimitMessage);
  rateLimitError.isRateLimit = true;
  rateLimitError.originalError = error;
  
  // Dispatch a custom event for components to listen to
  window.dispatchEvent(new CustomEvent('rateLimitError', {
    detail: { message: rateLimitMessage }
  }));
  
  return rateLimitError;
};
